import { render, staticRenderFns } from "./Stipulation.vue?vue&type=template&id=08f4c82d&"
import script from "./Stipulation.vue?vue&type=script&lang=js&"
export * from "./Stipulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports